import { formLimits, type FormFieldErrors } from '../config/formLimits'
import { containsWebLink, isSafeWebUrl, isSuspiciousMessage, isValidEmail, normalizePhone } from './formValidation'

export const joinSpecialties = [
  'Hair stylist',
  'Colorist',
  'Extension specialist',
  'Esthetician / skincare professional',
  'Lash / brow professional',
  'Other beauty professional',
]

export const joinExperienceOptions = ['Less than 2 years', '2–5 years', '6–10 years', '11+ years']

export const joinSpaceOptions = [
  'Styling station / chair',
  'Treatment room / private space',
  'Not sure — I’d like to discuss',
]

export const joinMessageLimit = 700

export type JoinInquiryValues = {
  name: string
  email: string
  rawPhone: string
  specialty: string
  experience: string
  portfolioUrl: string
  spaceInterest: string
  message: string
}

export function validateJoinInquiry(values: JoinInquiryValues, recaptchaAvailable: boolean) {
  const errors: FormFieldErrors = {}
  const phone = normalizePhone(values.rawPhone)

  if (!values.name) errors.name = 'Full name is required.'
  else if (values.name.length < 2) errors.name = 'Full name must contain at least 2 characters.'
  else if (values.name.length > formLimits.name) errors.name = `Full name must be ${formLimits.name} characters or fewer.`

  if (!values.email) errors.email = 'Email is required.'
  else if (values.email.length > formLimits.email) errors.email = `Email must be ${formLimits.email} characters or fewer.`
  else if (!isValidEmail(values.email)) errors.email = 'Enter a valid email address.'

  if (!values.rawPhone) errors.phone = 'Phone is required.'
  else if (values.rawPhone.length > formLimits.phone) errors.phone = `Phone must be ${formLimits.phone} characters or fewer.`
  else if (phone === null) errors.phone = 'Enter a valid phone number.'

  if (!values.specialty) errors.specialty = 'Profession or specialty is required.'
  else if (!joinSpecialties.includes(values.specialty)) errors.specialty = 'Select a valid profession or specialty.'

  if (!values.experience) errors.experience = 'Years of experience is required.'
  else if (!joinExperienceOptions.includes(values.experience)) errors.experience = 'Select a valid experience range.'

  if (values.portfolioUrl && values.portfolioUrl.length > formLimits.otherServiceDescription) errors.portfolioUrl = `Portfolio URL must be ${formLimits.otherServiceDescription} characters or fewer.`
  else if (values.portfolioUrl && !isSafeWebUrl(values.portfolioUrl)) errors.portfolioUrl = 'Enter a full secure URL beginning with https://.'

  if (!values.spaceInterest) errors.spaceInterest = 'Space interest is required.'
  else if (!joinSpaceOptions.includes(values.spaceInterest)) errors.spaceInterest = 'Select a valid space interest.'

  if (!values.message) errors.message = 'Please tell us a little about yourself.'
  else if (values.message.length < 10) errors.message = 'Your note must contain at least 10 characters.'
  else if (values.message.length > joinMessageLimit) errors.message = `Your note must be ${joinMessageLimit} characters or fewer.`
  else if (containsWebLink(values.message)) errors.message = 'Add portfolio links in the dedicated URL field above.'
  else if (isSuspiciousMessage(values.message)) errors.message = 'Please remove repeated text.'

  if (!recaptchaAvailable) errors.recaptcha = 'Human verification is unavailable.'
  return { errors, phone }
}

export function buildJoinInquiryMessage(values: JoinInquiryValues) {
  return [
    'JOIN US AVAILABILITY INQUIRY',
    `Profession / specialty: ${values.specialty}`,
    `Years of experience: ${values.experience}`,
    `Portfolio: ${values.portfolioUrl || 'Not provided'}`,
    `Space interest: ${values.spaceInterest}`,
    '',
    'About the professional:',
    values.message,
  ].join('\n')
}
